<!--Nav Start-->
<div class="d-flex flex-column"></div>
@if (order) {
  <div id="orderConfirmation_div_Order">
  <div class="d-flex flex-column" *ngLet="{
    isInternal: isInternal$ | async,
    isWarehouseManaged: (branch$ | async).isWarehouseManaged,
    printPickTicket: printPickTicket$ | async,
    readSAPOrder: readSAPOrder$ | async,
    createPurchaseOrder: createPurchaseOrder$ | async,
    currencyCode: currencyCode$ | async,
    procurementGroups: procurementGroups$ | async,
    orderConfirmationTotal: orderConfirmationTotal$ | async,
    isBagFeesEnabled: isBagFeesEnabled$ | async
  } as vm" >
      <div #printsection>
        <div class="occ-top-title bg-primary">
          <h4>
            @if (order.orderType === 'SalesOrder') {
              <span id="orderConfirmation_a_OrderPlaced">Your order has been placed.</span>
            }
            @if (order.orderType === 'Quote') {
              <span id="orderConfirmation_a_QuoteGenerated">Your quote has been generated.</span>
            }
            <span>&nbsp;</span>
            @if (order.orderType === 'SalesOrder') {
              <span id="orderConfirmation_a_OrderType0">Order confirmation</span>
            }
            @if (order.orderType === 'Quote') {
              <span id="orderConfirmation_a_OrderType1">Quote confirmation</span>
            }
            <span>&nbsp;</span>
            @if (vm.readSAPOrder) {
              <a id="orderConfirmation_a_DownloadSAPOrder"
              class="hyperlink strong" href="javascript:void(0)" (click)="downloadSAPShortCut()">#{{order.sapOrderNo}}</a>
            }
            @if (!vm.readSAPOrder) {
              <span id="orderConfirmation_a_ReadSAPOrder" class="strong">#{{order.sapOrderNo}}</span>
            }
            <span>&nbsp;</span>
            <a id="orderConfirmation_a_CopyToClipboard" class="far fa-clone text-body" href="javascript:void(0)" (click)="copyToClipBoard(order.sapOrderNo)"></a>
          </h4>
          @if (commonDataService.User?.isInternal && order.customerId != commonDataService.DefaultCustomer.rewardNumber) {
            <div id="orderConfirmation_div_CustomerNotes">
              <a id="orderConfirmation_a_CustomerNotes" class="hyperlink" href="javascript:void(0)" (click)="showCustomerNotes(order.customerId)">Customer Notes</a>
            </div>
          }
        </div>
        <div class="d-flex flex-wrap">
          <div class="col-sm-12 col-md-7 col-lg-7">
            @if (orderItems == null) {
              <div id="orderConfirmation_div_IsLoadingOrderItems" class="row">
                <h5>Loading order items...</h5>
              </div>
            }
            <div class="billing-table table-responsive">
              <div class="billing-right d-flex py-3 my-3 gx-3">
                <h5 class="strong mb-0">My Order</h5>
                @if (cartCount) {
                  <span id="orderConfirmation_span_CartCount">
                    {{cartCount}} {{(cartCount==1 || cartCount==0)?'ITEM' :'ITEMS'}}
                  </span>
                }
              </div>
              <div class="order-confirmation-table-scroll table-responsive my-cart-list-table">
                @if (orderItems && orderItems.length) {
                  <order-item-list
                    [orderItems]="orderItems"
                    [idSuffix]="KnownParts"
                    [showCouponColumn]="includesCouponData"
                    [orderItemCouponValues]="orderItemCouponValues"
                  ></order-item-list>
                }
                @if (partsBuyOutData && partsBuyOutData.length) {
                  <order-item-list
                    [orderItems]="partsBuyOutData"
                    [idSuffix]="PartsBuyout"
                    [showCouponColumn]="includesCouponData"
                    [orderItemCouponValues]="orderItemCouponValues"
                    header="PARTS BUYOUT"
                  ></order-item-list>
                }
                @if (hotFlagData && hotFlagData.length) {
                  <order-item-list
                    [orderItems]="hotFlagData"
                    [idSuffix]="HotFlag"
                    [showCouponColumn]="includesCouponData"
                    [orderItemCouponValues]="orderItemCouponValues"
                    [showHotFlagColumn]="true"
                    [notHotFlag95And99]="notHotFlag95And99"
                    [displayAllHotFlags]="true"
                    header="HOT FLAG"
                  ></order-item-list>
                }
                @if (stockTransferData && stockTransferData.length) {
                  <order-item-list
                    [orderItems]="stockTransferData"
                    [idSuffix]="StockTransferOrder"
                    [showCouponColumn]="includesCouponData"
                    [orderItemCouponValues]="orderItemCouponValues"
                    header="STOCK TRANSFER ORDER"
                    headerRight="Purchase Order will be created for the below items."
                  ></order-item-list>
                }
                @if (orderItems || partsBuyOutData || hotFlagData || stockTransferData) {
                  <div class="container">
                    <hr>
                      <div class="row">
                        @if (includesCouponData && orderType === 'Quote') {
                          <div id="orderConfirmation_div_StockTransferOrderCouponsExistAndQuote" class="col-md-10 text-danger">
                            Coupons may expire before the end of the quote period and affect the final price.
                          </div>
                        }
                      </div>
                      <div class="row mb-4">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font">Subtotal</div>
                        <div class="col-2 text-end bold-font">{{vm.orderConfirmationTotal.subTotal | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                        <div class="col-2"></div>
                      </div>
                      @if (vm.orderConfirmationTotal.cartCouponTotal != 0) {
                        <div class="row mb-4">
                          <div class="col-5"></div>
                          <div class="col-3 text-end bold-font text-nowrap">Cart Coupon Total</div>
                          <div class="col-2 text-end text-danger bold-font">{{vm.orderConfirmationTotal.cartCouponTotal | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                          <div class="col-2"></div>
                        </div>
                      }
                      <div class="row mb-4" [hidden]="!showFreightRow">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font text-nowrap">Estimated freight
                          @if (vm.orderConfirmationTotal.estimatedFreight == 0 && commonDataService.User?.isInternal) {
                            <i class="fas fa-info-circle info-btn"
                              placement="right" [ngbTooltip]="(0 | currency: vm.currencyCode :'symbol':'1.2-2') + ' freight/delivery will not be included on the order in SAP'">
                            </i>
                          }
                        </div>
                        <div class="col-2 text-end bold-font">{{vm.orderConfirmationTotal.estimatedFreight | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                        <div class="col-2"></div>
                      </div>
                      <div class="row mb-4" [hidden]="!showDeliveryRow">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font text-nowrap">Estimated delivery
                          @if (vm.orderConfirmationTotal.estimatedDelivery === 0 && commonDataService.User?.isInternal) {
                            <i class="fas fa-info-circle info-btn"
                              placement="right" [ngbTooltip]="(0 | currency: vm.currencyCode :'symbol':'1.2-2') + ' freight/delivery will not be included on the order in SAP'">
                            </i>
                          }
                        </div>
                        <div class="col-2 text-end bold-font">{{vm.orderConfirmationTotal.estimatedDelivery | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                        <div class="col-2"></div>
                      </div>
                      @if (deliveryFeeWithCreditVisible(order?.deliveryOptions, order?.deliveryFee) && vm.isBagFeesEnabled) {
                        <div class="row mb-4">
                          <div class="col-5"></div>
                          <div class="col-3 text-end bold-font text-nowrap">Retail Delivery Fee</div>
                          <div class="col-2 text-end bold-font">{{ vm.orderConfirmationTotal.deliveryFee | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                          <div class="col-2"></div>
                        </div>
                        @if (order.deliveryFeeCredit !== 0) {
                          <div class="row mb-4">
                            <div class="col-5"></div>
                            <div class="col-3 text-end bold-font text-nowrap">Delivery Fee Credit</div>
                            <div class="col-2 text-end bold-font">{{ vm.orderConfirmationTotal.deliveryFeeCredit | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                            <div class="col-2"></div>
                          </div>
                        }
                      }
                      <div class="row mb-4">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font text-nowrap">Estimated sales tax</div>
                        <div class="col-2 text-end bold-font">{{vm.orderConfirmationTotal.taxAmount | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                        <div class="col-2"></div>
                      </div>
                      <div class="row mb-4">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font">
                          TOTAL@if (!commonDataService.User?.isInternal) {
                          <span style="position: absolute">*</span>
                        }
                      </div>
                      <div class="col-2 text-end bold-font">{{vm.orderConfirmationTotal.total | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                      <div class="col-2"></div>
                    </div>
                    @if (vm.orderConfirmationTotal.couponTotal != 0) {
                      <div class="row mb-4">
                        <div class="col-5"></div>
                        <div class="col-3 text-end bold-font text-nowrap">Your Savings</div>
                        <div class="col-2 text-end text-danger bold-font">{{vm.orderConfirmationTotal.couponTotal | currency: vm.currencyCode :'symbol':'1.2-2'}}</div>
                        <div class="col-2"></div>
                      </div>
                    }
                  </div>
                }
              </div>
              @if (!commonDataService.User?.isInternal) {
                <div id="orderConfirmation_div_UserInternalNoTaxNoShipping" style="text-align: right; padding-top: 20px; padding-right: 135px; font-size: 12px">
                  *Does not include actual tax or shipping
                </div>
              }
            </div>
          </div>
          <!--<div class="col-sm-12 col-md-1 col-lg-1 text-align-left"></div>-->
          <div class="col-sm-12 col-md-5 col-lg-5 text-align-left">
            @if (order == null) {
              <div id="orderConfirmation_div_LoadingOrderDetails">
                <h5>Loading order details...</h5>
              </div>
            }
            <table class="table order">
              <tr>
                <td>
                  <h1>Customer Name:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.soldToName1}}
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Rewards Number:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.customerId}}
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Branch:</h1>
                </td>
                <td class="order-billing-summary-text">
                  <span class="p-0" *ngLet="branch$ | async as branch">{{branch?.code}} - {{branch?.displayName}}</span>
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Billing:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.soldToName1}}
                  <br />{{order.soldToAddress}}
                  <br />{{order.soldToCity !='' && order.soldToCity !=null && order.soldToCity !=undefined?
                  order.soldToCity + ',':''}} {{order.soldToState}} {{order.soldToZip}}
                  <br />{{order.soldToPhone}}
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Payer:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.billingType}}
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Delivery:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{uniqueDeliveryItems.length >= 2 ? 'Multiple' : deliveryOption}}
                </td>
              </tr>
              <tr>
                <td>
                  <h1>Alternate Shipping Address:</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.shipToName1}}
                  <br />{{order.shipToAddress}}
                  <br />{{order.shipToCity !='' && order.shipToCity !=null && order.shipToCity !=undefined ?
                  order.shipToCity + ',':''}} {{order.shipToState}} {{order.shipToZip}}
                  <br />{{order.shipToPhone}}
                </td>
              </tr>
              @if (commonDataService.User?.isInternal) {
                <tr id="orderConfirmation_tr_UserInternalSalespersonAndSpecialInstructions">
                  <td>
                    <h1>Salesperson:</h1>
                  </td>
                  <td class="order-billing-summary-text">
                    {{order.salesPerson != null && order.salesPerson != '' ? order.salesPerson : "Not available"}}
                  </td>
                </tr>
              }
              <tr>
                <td>
                  <h1>Special Instructions</h1>
                </td>
                <td class="order-billing-summary-text">
                  {{order.specialInstructions==""? "None" : order.specialInstructions}}
                </td>
              </tr>
              @if (order.shipComplete) {
                <tr>
                  <td></td>
                  <td>
                    Ship Complete
                  </td>
                </tr>
              }
            </table>
          </div>
        </div>
      </div>
    <div class="d-flex justify-content-center order-confirmation-btn" *ngLet="{
      createBillingShown: createBillingShown$ | async,
      createBillingEnabled: createBillingEnabled$ | async,
      canCreateBilling: canCreateBilling$ | async
    } as billingvm">
        @if (order.orderType === 'Quote') {
          <button id="orderConfirmation_button_PrintQuote" type="button" class="btn btn-default yellow-btn margin-r-5"
            [disabled]="createBillingFlag"
            (click)="printSAPQuote()">
            Print Quote
          </button>
        }
        @if (order.orderType === 'SalesOrder' && !vm.isInternal) {
          <button id="orderConfirmation_button_PrintConfirmation" type="button" class="btn btn-default yellow-btn margin-r-5"
            (click)="printDiv()">
            Print Confirmation
          </button>
        }
        <span>
          @if (showCreatePOButton && vm.createPurchaseOrder && isShowCreatePOButton && vm.procurementGroups) {
            <button id="orderConfirmation_button_CreatePO" type="button" class="btn btn-default yellow-btn margin-r-5"
              [disabled]="((createBillingFlag && !vm.isWarehouseManaged) || printPOFlag) && vm.createPurchaseOrder"
              (click)="createPurchaseOrders()">
              @if (!isShowHotFlagCreatePOButton && hotFlag95And99Data.length == 0) {
                <span>Create PO</span>
              }
              @if (!isShowHotFlagCreatePOButton && hotFlag95And99Data.length > 0) {
                <span>Create Req or PO</span>
              }
            </button>
          }
          @if (isShowHotFlagCreatePOButton && vm.procurementGroups) {
            <button id="orderConfirmation_button_CreatePO_hotFlag" type="button" class="btn btn-default yellow-btn margin-r-5"
              [disabled]="((createBillingFlag && !vm.isWarehouseManaged) || printPOFlag) && vm.createPurchaseOrder"
              (click)="createPurchaseOrders()">
              Create Req or PO
            </button>
          }
          @if (vm.printPickTicket &&
            vm.isWarehouseManaged && (readyToPickShown$ | async)) {
            <ng-container id="orderConfirmation_container_PrintPickingTicket"
              >
              @if (order?.orderType === 'SalesOrder' &&
                (partsBuyOutData.length > 0 || stockTransferData.length > 0 || hotFlag95And99Data.length > 0) &&
                (showCreatePOButton && vm.createPurchaseOrder && isShowCreatePOButton && vm.procurementGroups)) {
                <span
                >Or</span>
              }
              @if (order?.orderType === 'SalesOrder' && vm.printPickTicket && vm.isWarehouseManaged) {
                <button id="orderConfirmation_button_PrintPickingTicket" type="button" class="btn btn-default yellow-btn margin-r-5"
                  [disabled]="!(readyToPickEnabled$ | async) || isRTPDisabled"
                  (click)="readyToPick()">
                  Ready To Pick
                </button>
              }
            </ng-container>
          } @else {
            @if (order.orderType === 'SalesOrder' && (partsBuyOutData.length > 0 || stockTransferData.length > 0) &&
              vm.printPickTicket && !vm.isWarehouseManaged) {
              <span id="orderConfirmation_span_LegacyPrintPickingTicket"
              >Or</span>
            }
            @if (order.orderType === 'SalesOrder' && vm.printPickTicket && !vm.isWarehouseManaged) {
              <button id="orderConfirmation_button_LegacyPrintPickingTicket" type="button" class="btn btn-default yellow-btn margin-r-5"
                [disabled]="createBillingFlag || printPickTicketFlag"
                (click)="getPickTicket()">
                Print Pick Ticket
              </button>
            }
          }
          @if (!vm.isBagFeesEnabled && billingvm.createBillingShown && billingvm.canCreateBilling) {
            <ng-container id="orderConfirmation_container_CreateBilling">
              <button id="orderConfirmation_button_CreateBilling" type="button" class="btn btn-default yellow-btn margin-r-5"
                [disabled]="!billingvm.createBillingEnabled || createBillingButtonClicked"
                (click)="createBilling(vm.isBagFeesEnabled);">
                Create Billing
              </button>
            </ng-container>
          }
          @if (vm.isBagFeesEnabled && billingvm.createBillingShown && billingvm.canCreateBilling) {
            <ng-container id="orderConfirmation_container_CreateBilling">
              @if (branch$ | async; as branch) {
                <button id="orderConfirmation_button_CreateBilling" type="button" class="btn btn-default yellow-btn margin-r-5"
                  [disabled]="!billingvm.createBillingEnabled || createBillingButtonClicked"
                  (click)="onCreateBilling(vm.isBagFeesEnabled);">
                  Create Billing
                </button>
              }
            </ng-container>
          }
        </span>
        <span>
          <a class="mb-0 ms-5 hyperlink cursor-pointer" (click)="clearCustomerValue()" href="#">
            New Search
          </a>
        </span>
      </div>
    </div>
  </div>
}

<ng-template id="orderConfirmation_template_CreateBillingModal" #createBillingModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">IBS/MSC Authorization Number</h4>
    <button id="orderConfirmation_button_Close" type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @for (errMsg of createBillingErrorMsgs; track errMsg; let i = $index) {
      <div id="orderConfirmation_div_CreateBillingErrorMessages_{{i}}">
          <div class=" alert" [ngClass]="errMsg.type == 5 ? 'alert-multi-line'
                              : errMsg.type == 0 ? 'alert-success'
                              : errMsg.type == 1 ? 'alert-info'
                              : errMsg.type == 2 ? 'alert-warning' : 'alert-danger'" style="margin-bottom: 5px;">
        <i id="orderConfirmation_i_NotificationIcon_{{i}}" class="fas" [ngClass]="errMsg.type == 5 ? ''
                           : errMsg.type == 0 ? 'fa fa-check-circle success'
                          : errMsg.type == 1 ? 'fa fa-exclamation-triangle info'
                          : errMsg.type == 2 ? 'fa fa-exclamation-triangle warning'
                          : errMsg.type == 3 ? 'fa fa-times-circle danger'
                          : 'fa fa-exclamation-circle danger'"></i>
          &nbsp;
        <span [ngClass]="errMsg.type == 5 ? ''
                              : errMsg.type == 0 ? 'success'
                              : errMsg.type == 1 ? 'info'
                              : errMsg.type == 2 ? 'warning' : 'danger'">{{errMsg.message}}</span><br />
        </div>
      </div>
      }<br />
      <form>
        <div class="form-group">
          <div class="input-group">
            <input id="orderConfirmation_text_AuthorizationNumber_{{i}}" class="form-control" type="text" [(ngModel)]="authorizationNumber"
              name="authorizationNumber" maxlength="10" (keypress)="onCreateBillingKeypress($event)">
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button id="orderConfirmation_button_Submit" type="button" class="btn btn-md black-text btnBg yellow-btn"
          [disabled]="!authorizationNumber" (click)="submitIBSOverrideCreateBilling(vm.isBagFeesEnabled)" data-dismiss="modal">
          Submit
          Override & Create Billing
        </button>
      </div>
    </ng-template>